import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { impersonateUser } from '~/redux/actions/admin-users-actions.js';
import { failure } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message.js';
import ConfirmModal from '~/components/General/ConfirmModal';

// Icons
import { User2CIcon } from '~/assets/images';

const ImpersonateModal = (props) => {
  const { selectedUser, handleClose, open } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const impersonate = async () => {
    try {
      setLoading(true);
      const request = await dispatch(impersonateUser(selectedUser?.id));
      if (request.status !== 200) {
        dispatch(failure(request?.response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || MESSAGES.GENERAL_ERROR));
    } finally {
      handleClose();
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open,
        header: 'Impersonation',
        message: `${MESSAGES.ADMIN_DASHBOARD.USERS.IMPERSONATION.IMPERSONATE_MODAL.HEADING} ${selectedUser?.name}?`,
        icon: User2CIcon,
        handleOk: impersonate,
        handleClose,
        loading,
        successButtonName:
          MESSAGES.ADMIN_DASHBOARD.USERS.IMPERSONATION.IMPERSONATE_MODAL.SUBMIT_BUTTON,
        cancelButtonName:
          MESSAGES.ADMIN_DASHBOARD.USERS.IMPERSONATION.IMPERSONATE_MODAL.CANCEL_BUTTON,
        compactActions: true,
      }}
    />
  );
};

export default ImpersonateModal;
